"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaymentMethodCreateDefault = exports.usePaymentMethodbulkSave = exports.usePaymentMethodUpdate = exports.usePaymentMethodCreate = exports.usePaymentMethodFetch = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const paymentMethodAction_1 = require("./paymentMethodAction");
const usePaymentMethodFetch = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const paymentMethodFetchLoading = (0, react_redux_1.useSelector)((state) => state["paymentMethod/list"].loading);
    const paymentMethodFetchError = (0, react_redux_1.useSelector)((state) => state["paymentMethod/list"].error);
    const paymentMethodFetchData = (0, react_redux_1.useSelector)((state) => state["paymentMethod/list"].data);
    const fetchPaymentMethod = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, paymentMethodAction_1.fetch)(payload));
    });
    return {
        paymentMethodFetchLoading,
        paymentMethodFetchError,
        paymentMethodFetchData,
        fetchPaymentMethod
    };
};
exports.usePaymentMethodFetch = usePaymentMethodFetch;
const usePaymentMethodCreate = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const paymentMethodCreateLoading = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create"].loading);
    const paymentMethodCreateError = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create"].error);
    const paymentMethodCreateData = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create"].data);
    const createPaymentMethod = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, paymentMethodAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Payment Method created successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error;
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        paymentMethodCreateLoading,
        paymentMethodCreateError,
        paymentMethodCreateData,
        createPaymentMethod
    };
};
exports.usePaymentMethodCreate = usePaymentMethodCreate;
const usePaymentMethodUpdate = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const paymentMethodUpdateLoading = (0, react_redux_1.useSelector)((state) => state["paymentMethod/update"].loading);
    const paymentMethodUpdateError = (0, react_redux_1.useSelector)((state) => state["paymentMethod/update"].error);
    const paymentMethodUpdateData = (0, react_redux_1.useSelector)((state) => state["paymentMethod/update"].data);
    const updatePaymentMethod = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, paymentMethodAction_1.update)(payload));
            console.log("the response", res);
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Payment Method updated successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error;
            }
        }
        catch (error) {
            console.log("errrororrr", error);
            onComplete(false, true, error.message);
        }
    });
    return {
        paymentMethodUpdateLoading,
        paymentMethodUpdateError,
        paymentMethodUpdateData,
        updatePaymentMethod
    };
};
exports.usePaymentMethodUpdate = usePaymentMethodUpdate;
const usePaymentMethodbulkSave = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const paymentMethodSaveLoading = (0, react_redux_1.useSelector)((state) => state["paymentMethod/bulk_save"].loading);
    const paymentMethodSaveError = (0, react_redux_1.useSelector)((state) => state["paymentMethod/bulk_save"].error);
    const paymentMethodSaveData = (0, react_redux_1.useSelector)((state) => state["paymentMethod/bulk_save"].data);
    const bulkSavePaymentMethod = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, paymentMethodAction_1.bulk_save)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Payment Method saved successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in saving Payment Method");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        paymentMethodSaveLoading,
        paymentMethodSaveError,
        paymentMethodSaveData,
        bulkSavePaymentMethod
    };
};
exports.usePaymentMethodbulkSave = usePaymentMethodbulkSave;
const usePaymentMethodCreateDefault = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const paymentMethodCreateDefaultLoading = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create_default"].loading);
    const paymentMethodCreateDefaultError = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create_default"].error);
    const paymentMethodCreateDefaultData = (0, react_redux_1.useSelector)((state) => state["paymentMethod/create_default"].data);
    const createDefaultPaymentMethod = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, paymentMethodAction_1.create_default)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Default Payment Method created successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error;
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        paymentMethodCreateDefaultLoading,
        paymentMethodCreateDefaultError,
        paymentMethodCreateDefaultData,
        createDefaultPaymentMethod
    };
};
exports.usePaymentMethodCreateDefault = usePaymentMethodCreateDefault;
